<div class="flex flex-col">
  @if (listStore.hasSearchResults()) {
    <app-sidebar-item
      class="rounded hover:bg-hover"
      title="All Results"
      icon="sapphire-search"
      [minimized]="minimized()"
      [active]="listStore.view() === 'search_results' && !listStore.folderId() && !listStore.foldersOpen()"
      (appClick)="listStore.landOnSearchResults()"
    />
  }
  @for (item of baseItems; track item.id) {
    <app-sidebar-item
      class="rounded [&:not(.drag-over)]:hover:bg-hover"
      [title]="item.title"
      [minimized]="minimized()"
      [attr.aria-label]="item.title"
      role="button" tabindex="0"
      (keydown.enter)="selectView(item.id)"
      (keydown.space)="$event.preventDefault(); selectView(item.id)"
      [icon]="item.icon"
      [badge]="item.id === 'all' ? { template: allCountTemplate, context: { count: allBoardsCount() } } : undefined"
      [active]="listStore.view() === item.id && !listStore.folderId() && !listStore.foldersOpen()"
      (appClick)="selectView(item.id)"
      [appBoardsSidebarContextMenu]="item.id"
      (appBoardsSidebarContextMenuFolderCreated)="showCreatedFolder($event)"
      appDroppable
      appDroppableHoverClass="drag-over"
      [appDroppablePredicate]="dndPredicate"
      (appDroppableDrop)="dndDropOnView($event, item.id)"
    />
  }

  <app-sidebar-items-divider />

  <div
    stchPopover
    [stchPopoverArrow]="true"
    [stchPopoverContent]="foldersPopoverTemplate"
    [stchPopoverInnerShadow]="true"
    stchPopoverPlacement="right"
    [stchPopoverDisabled]="!minimized()"
    stchPopoverTrigger="click"
  >
    <app-sidebar-item
      class="rounded [&:not(.drag-over)]:hover:bg-hover"
      title="Folders"
      icon="sapphire-folders"
      [expandable]="true"
      [expanded]="foldersExpanded()"
      [minimized]="minimized()"
      [active]="listStore.foldersOpen()"
      [actions]="[{ icon: 'sapphire-plus', tooltip: 'New folder', template: folderQuickFormTemplate, until: quickFormPopoverClose, appearance: 'dialog' }]"
      (onExpand)="setFoldersExpanded($event)"
      (appClick)="selectFolders()"
      appBoardsSidebarContextMenu="folders"
      (appBoardsSidebarContextMenuFolderCreated)="showCreatedFolder($event)"
    >
      <app-context-menu-state-indicator appearance="sapphire" svgIcon="sapphire-ellipsis" appBoardsFoldersListContextMenu />
    </app-sidebar-item>
  </div>

  @if (!minimized()) {
    <div class="overflow-hidden" [@heightAnimation]="foldersExpanded() ? 'show' : 'hide'">
      <ng-container *ngTemplateOutlet="foldersListTemplate" />
    </div>
  }

  <ng-template #foldersPopoverTemplate>
    @if (minimized()) {
      <div class="m-4 h-[216px] w-[200px] overflow-auto">
        <ng-container *ngTemplateOutlet="foldersListTemplate" />
      </div>
    }
  </ng-template>

  <ng-template #foldersListTemplate>
    @if (visibleFolders().length === 0) {
      <span class="text-subdued px-8 py-2 text-sm">No folders found</span>
    }
    @for (folder of visibleFolders(); track folder.id) {
      <app-sidebar-item
        class="rounded [&:not(.drag-over)]:hover:bg-hover"
        [title]="folder.title"
        iconSlot="none"
        [active]="listStore.folderId() === folder.id"
        [badge]="{ template: badgeTemplate, context: { pinned: folder.pinned, flagged: folder.flagged } }"
        (appClick)="selectFolder(folder.id)"
        [appBoardsFolderContextMenu]="folder"
        (appBoardsFolderContextMenuOpen)="selectFolder(folder.id, $event)"
        (appBoardsFolderContextMenuBoardCreated)="openCreatedBoard(folder.id, $event)"
        (appBoardsFolderContextMenuDuplicated)="selectFolder($event)"
        appDroppable
        appDroppableHoverClass="drag-over"
        [appDroppablePredicate]="folderDndPredicate"
        (appDroppableDrop)="dndDropOnFolder($event, folder)"
      />
    }
  </ng-template>

  <!-- Prototype rail: "All boards" carries its count (screenshot 05). -->
  <ng-template #allCountTemplate let-count="count">
    <span class="text-xs text-subdued" data-testid="all-boards-count">{{ count }}</span>
  </ng-template>

  <ng-template #badgeTemplate let-pinned="pinned" let-flagged="flagged">
    <div class="flex h-full flex-col items-center justify-center">
      @if (pinned) {
        <app-icon class="text-primary" size="xs" name="sapphire-pin-filled" />
      }
      @if (flagged) {
        <app-icon class="text-orange-500" size="xs" name="sapphire-flagged-filled" />
      }
    </div>
  </ng-template>

  <app-sidebar-items-divider />

  <!-- Pinned Knots · Pinned Tags · Pinned Connections, no lines between, as every app's personal rail (Johanna, 2026-10-21). -->
  <app-knowledge-items-rail [sidebarSplitViewKey]="SidebarSplitViewKey.boards" />
</div>

<ng-template #folderQuickFormTemplate>
  <div class="box-border w-[var(--quick-form-dialog-width-rail)]">
    <app-boards-quick-form
      placeholder="Untitled folder"
      [autofocus]="true"
      (save)="createFolder($event)"
      (close)="quickFormPopoverClose.next()"
    />
  </div>
</ng-template>
